import * as React from "react";
import { RegulatoryCheckInfoStatus } from "../../../../../../Wrap/Constants/Enums/Customer/RegulatoryCheckInfoStatus";
import { RegulatoryCheckInfoType } from "../../../../../../Wrap/Constants/Enums/Customer/RegulatoryCheckInfoType";
import { RegulatoryCheckDetailsModel } from "../../../../../../Wrap/Models/Models/Customer/RegulatoryCheckDetailsModel";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { RegulatoryCheckInfoTypeMap, RegulatoryCheckResultTypeMap } from "../../ClientRecord/Resource/Contents";
import { prepareTypography } from "../../Common/Review/ReviewParser";
import { fieldDefaultValue } from "../Resource/CustomerMergeHelper";

interface IRegulatoryChecksProps {
    tData: Array<RegulatoryCheckDetailsModel>;
}

const regulatoryChecksConfig = (tData: Array<RegulatoryCheckDetailsModel>) => {
    const aml = tData?.find((e) => e?.RegulatoryCheckType == RegulatoryCheckInfoType.AML);
    const pep = tData?.find((e) => e?.RegulatoryCheckType == RegulatoryCheckInfoType.PEP);

    return [
        {
            title: "AML method",
            data: fieldDefaultValue(
                aml?.ServiceProvider != null && (aml?.ServiceProvider == "Manual" || aml?.ServiceProvider == "Experian")
                    ? aml?.ServiceProvider
                    : ""
            ),
        },
        {
            title: "AML check status",
            data: fieldDefaultValue(RegulatoryCheckInfoTypeMap[aml?.RegulatoryCheckStatus]),
        },
        {
            title: "AML status",
            data: fieldDefaultValue(RegulatoryCheckResultTypeMap[aml?.RegulatoryCheckResult]),
        },
        {
            title: "PEP check status",
            data: fieldDefaultValue(RegulatoryCheckInfoTypeMap[pep?.RegulatoryCheckStatus]),
        },
        {
            title: "PEP status",
            data: fieldDefaultValue(
                pep == null || pep?.RegulatoryCheckResult == null
                    ? " "
                    : pep?.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.NotVetted ||
                      pep?.RegulatoryCheckStatus == RegulatoryCheckInfoStatus.SelfCertified
                    ? "N/A"
                    : RegulatoryCheckResultTypeMap[pep?.RegulatoryCheckResult]
            ),
        },
    ];
};

export const RegulatoryChecks = (props: IRegulatoryChecksProps) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h3>
                        <u>Regulatory checks</u>
                    </h3>
                </div>
            </div>
            <Typography {...prepareTypography(regulatoryChecksConfig(props.tData), 1, "common")} />
        </>
    );
};
